import { request } from "../lib/http";

export function fetchLast30Positions(vehicleId) {
  return request({
    url: "last-positions",
    method: "get",
    params: {
      vehicleId,
    },
  });
}
